import { useEffect, useState } from "react";
import { api } from "../api/client";

export default function AdminAlerts() {
  const [alerts, setAlerts] = useState<any[]>([]);

  useEffect(() => {
    api.get("/admin/alerts?unresolved_only=true").then((r: any) => setAlerts(r.data));
  }, []);

  const resolve = async (id: number) => {
    await api.post(`/admin/alerts/${id}/resolve`, { resolved: true });
    setAlerts(alerts.filter((a) => a.id !== id));
  };

  return (
    <div className="p-4 space-y-3">
      <h1 className="text-xl font-bold">Алерты</h1>
      {alerts.map((a) => (
        <div key={a.id} className={`p-3 rounded-xl ${a.severity === "CRITICAL" ? "bg-red-900/30" : "bg-yellow-900/30"}`}>
          <div className="font-semibold">{a.alert_type} — {a.severity}</div>
          <div className="text-sm">{a.message}</div>
          <button onClick={() => resolve(a.id)} className="mt-2 px-3 py-1 rounded bg-[var(--tg-theme-button-color)] text-[var(--tg-theme-button-text-color)] text-sm">
            Закрыть
          </button>
        </div>
      ))}
      {alerts.length === 0 && <div className="opacity-60">Все системы в норме 🎉</div>}
    </div>
  );
}
